<template>
  <div v-if="column === accountColumnKeys.ACCOUNT_ID" class="flex items-center gap-2 overflow-hidden">
    <ProfileIcon
      :data="{ author: row.account_id, author_avatar: row.avatar_url }"
      avatar="author_avatar"
      :view="true"
      param="author"
      :size="28"
      :font="12"
    />
    <span class="proxima_nova text-sm text_color truncate">
      {{ row.account_id || 'GitHub User' }}
    </span>
  </div>

  <StatusTagProvider
    v-else-if="column === accountColumnKeys.STATUS"
    source="code_reviewer_settings"
    :value="accountStatusLabels[getAccountStatus(row)]"
    :text="accountStatusLabels[getAccountStatus(row)]"
  />

  <span v-else-if="column === accountColumnKeys.REPO_COUNT" class="proxima_nova text-sm text_color">
    {{ row.repo_count ?? 0 }}
  </span>

  <div v-else-if="column === accountColumnKeys.IS_PRIMARY">
    <span
      v-if="row.is_primary"
      class="px-3 py-1 text-xs rounded-full border border_lg text_color"
      :style="{ backgroundColor: 'var(--sidebar-item-selected)' }"
    >
      Primary
    </span>
  </div>
</template>

<script setup>
import ProfileIcon from "@/src/components/ProfileIcon.vue";
import StatusTagProvider from "@/src/components/StatusTagProvider.vue";
import {
  accountColumnKeys,
  accountStatusLabels,
  getAccountStatus,
} from "@/src/constants/codeReviewerConstants.js";

defineProps({
  row: { type: Object, required: true },
  value: { type: [String, Number, Object], default: null },
  column: { type: String, default: "" },
});
</script>

